import { render, staticRenderFns } from "./ClientSms.vue?vue&type=template&id=68ac0706&scoped=true"
import script from "./ClientSms.vue?vue&type=script&lang=js"
export * from "./ClientSms.vue?vue&type=script&lang=js"
import style0 from "./ClientSms.vue?vue&type=style&index=0&id=68ac0706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ac0706",
  null
  
)

export default component.exports